<article
  class="notification-item"
  [class.notification-item--read]="!!notification.readAt"
  [class.notification-item--compact]="compact"
  [attr.data-variant]="notification.variant"
>
  <div class="notification-item__media">
    @if (notification.imageUrl) {
      <img
        class="notification-item__image"
        [src]="notification.imageUrl"
        [alt]="notification.title"
      />
    } @else {
      <span class="notification-item__fallback" aria-hidden="true">N</span>
    }
  </div>

  <div class="notification-item__body">
    <div class="notification-item__headline">
      <strong class="notification-item__title">{{ notification.title }}</strong>
      <span class="notification-item__time">{{ timestampLabel }}</span>
    </div>

    <p class="notification-item__description">{{ notification.description }}</p>
  </div>
</article>
